import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import { MdNotificationsActive } from "react-icons/md";
import ProfilePopup from "./NavbarProfilePopup";
import MobileSidebar from "./NavbarMobileSidebar";

const Navbar = ({ handleLogout, token, userDetails }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isMobileOptionMenuOpen, setIsMobileOptionMenuOpen] = useState(false);
  const location = useLocation();

  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  const toggleMobileOptionMenu = () => {
    setIsMobileOptionMenuOpen(!isMobileOptionMenuOpen);
  };

  // Create a ref to the mobile sidebar element
  const mobileSidebarRef = useRef(null);

  const popupContainerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click target is outside of both the mobile menu and the popup container
      if (
        (isMobileOptionMenuOpen &&
          mobileSidebarRef.current &&
          !mobileSidebarRef.current.contains(event.target)) ||
        (isPopupVisible &&
          popupContainerRef.current &&
          !popupContainerRef.current.contains(event.target))
      ) {
        setIsMobileOptionMenuOpen(false);
        setIsPopupVisible(false);
      }
    };

    // Add event listener when either the mobile menu or the profile popup is open
    if (isMobileOptionMenuOpen || isPopupVisible) {
      document.addEventListener("click", handleClickOutside);
    }

    // Remove event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isMobileOptionMenuOpen, isPopupVisible]);

  return (
    <nav className="bg-white sticky top-0 z-50">
      <div className="max-w-full px-5 lg:px-44">
        <div className="flex items-center justify-between h-16 ">
          <div className="w-[9rem] flex-shrink-0">
            <a href="/">
              <img src="/images/logo.png" alt="fynii" />
            </a>
          </div>
          <div className="hidden md:flex items-center space-x-4">
            {token ? (
              <div className="flex flex-row space-x-10 relative">
                <a
                  href="/home"
                  className={`flex flex-col items-center justify-center ${
                    location.pathname === "/home"
                      ? "text-indigo-600 "
                      : "text-black"
                  }`}
                >
                  <FaHome className="text-2xl" />
                  <span className="text-xs font-semibold">Home</span>
                </a>

                <a
                  href="/notifications"
                  className={`flex flex-col items-center justify-center ${
                    location.pathname === "/notifications"
                      ? "text-indigo-600 "
                      : "text-black"
                  }`}
                >
                  <MdNotificationsActive className="text-2xl" />
                  <span className="text-xs font-semibold">Notification</span>
                </a>
                <a
                  href="/magicAI"
                  className={`flex flex-col items-center justify-center ${
                    location.pathname === "/magicAI"
                      ? "bg-clip-text text-transparent bg-gradient-to-r from-rose-900 via-red-400 to-indigo-600"
                      : ""
                  }`}
                >
                  <span className="font-titillium-web text-xl font-extrabold">
                    MagicAI
                  </span>
                </a>

                <div
                  ref={popupContainerRef}
                  onClick={togglePopup}
                  className="popup-container flex items-center cursor-pointer h-full"
                >
                  <img
                    className="h-12 w-12 rounded-full cursor-pointer"
                    src={userDetails.profileImageUrl}
                    alt="Profile"
                  />
                </div>

                {isPopupVisible && (
                  <ProfilePopup
                    handleLogout={handleLogout}
                    userDetails={userDetails}
                  />
                )}
              </div>
            ) : (
              <div className="flex items-center space-x-4">
                <a
                  href="/magicAI"
                  className={`flex flex-col items-center justify-center ${
                    location.pathname === "/magicAI"
                      ? "font-titillium-web text-xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-rose-900 via-red-400 to-indigo-600"
                      : "font-titillium-web text-xl font-extrabold"
                  }`}
                >
                  <span className="">MagicAI</span>
                </a>
                <a
                  href="/userlogin"
                  className="px-4 py-2 rounded-md border  font-semibold border-cyan-600 text-cyan-600 cursor-pointer  hover:text-black"
                >
                  Login
                </a>
                <a
                  href="/usersignup"
                  className="px-4 py-2 rounded-md border text-white font-semibold  bg-gradient-to-r from-sky-400  to-indigo-600 cursor-pointer hover:from-indigo-600 hover:to-sky-400 transition-colors duration-300 hover:text-gray-100"
                >
                  Sign up
                </a>
              </div>
            )}
          </div>

          <div className="md:hidden" ref={mobileSidebarRef}>
            <button
              onClick={toggleMobileOptionMenu}
              className="text-gray-600 hover:text-black focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>

            {/* Mobile Sidebar */}
            {isMobileOptionMenuOpen && (
              <MobileSidebar
                handleLogout={handleLogout}
                token={token}
                userDetails={userDetails}
              />
            )}
          </div>
        </div>
      </div>
      {/* Black line at the end of the nav */}
      <div className="h-[1px] bg-gray-400"></div>
    </nav>
  );
};

export default Navbar;
